import { logsSocketHelper } from 'src/app/helpers';
import { GameState } from 'src/enums/game-state.enum';
import { reduxEventTypes } from 'src/types';
import {
  EVENTS_SET,
  EVENT_ADDED,
  EVENT_DATA_CHANGED,
  EVENT_DATE_CHANGED,
  EVENT_EDITED,
  EVENT_ID_CHANGED,
  EVENT_STATE_CHANGED,
  SURFER_STATE_CHANGED,
  TH_TC_CHANGED,
  EVENT_DELETED,
  EVENT_TIME_PREFERENCE_CHANGED,
  EVENT_UNIX_TIME_CHANGED,
} from '../redux-types/event.types';

export const eventDefaultState: reduxEventTypes.StateType = {
  eventName: '',
  eventClassification: '',
  eventId: '',
  eventState: GameState.Default,
  hour: new Date().getHours(),
  eventDate: new Date().getTime(),
  isSurferOn: undefined,
  tc: 1,
  th: 5,
  eventList: [],
  hymotsDB: 0,
  hymotseLogin: false,
  HLAContent: undefined,
  timePreference: 1,
  currentUnixTime: 0,
};

export const eventReducer = (
  state = eventDefaultState,
  action: reduxEventTypes.ActionType,
): reduxEventTypes.StateType => {
  switch (action.type) {
    case EVENTS_SET:
      return {
        ...state,
        eventList: action.payload,
      };
    case EVENT_ADDED:
      // eslint-disable-next-line no-case-declarations
      const exists = state.eventList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        eventList: [action.payload, ...state.eventList],
      };
    case EVENT_EDITED:
      // eslint-disable-next-line no-case-declarations
      const updateIndex = state.eventList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        eventList: [
          ...state.eventList.slice(0, updateIndex),
          action.payload,
          ...state.eventList.slice(updateIndex + 1),
        ],
      };
    case EVENT_DELETED:
      return {
        ...state,
        eventList: state.eventList.filter((o) => o.id !== action.payload),
      };
    case EVENT_DATA_CHANGED:
      return {
        ...state,
        eventName: action.payload.eventName,
        eventClassification: action.payload.eventClassification,
        hymotsDB: action.payload.hymotsDB,
      };
    case EVENT_ID_CHANGED:
      const newEventName = state.eventList.find((e) => e.id === action.payload)?.eventId;
      const newHymotsDB = state.eventList.find((e) => e.id === action.payload)?.hymotsDB;
      return {
        ...state,
        eventId: action.payload,
        eventName: newEventName ? newEventName : '',
        hymotsDB: newHymotsDB,
      };
    case EVENT_TIME_PREFERENCE_CHANGED:
      return {
        ...state,
        timePreference: action.payload,
      };
    case EVENT_UNIX_TIME_CHANGED:
      return {
        ...state,
        currentUnixTime: action.payload,
      };
    case EVENT_STATE_CHANGED:
      return {
        ...state,
        eventState: action.payload,
      };
    case EVENT_DATE_CHANGED:
      return {
        ...state,
        eventDate: action.payload,
      };
    case SURFER_STATE_CHANGED:
      return {
        ...state,
        isSurferOn: action.payload,
      };
    case TH_TC_CHANGED:
      return {
        ...state,
        th: action.payload.th,
        tc: action.payload.tc,
      };
    case 'HYMOTSE_LOGIN':
      return {
        ...state,
        hymotseLogin: action.payload,
      };

    case 'HLA_CONTENT_CHANGED':
      return {
        ...state,
        HLAContent: action.payload,
      };

    default:
      return state;
  }
};
